<template>
  <div>
      <Row :gutter="10">
        <Col span="12">
            <Form :model="baseForm" :rules="baseRules" ref="baseForm">
              <FormItem prop="name">
                <Input type="text" v-model="baseForm.name" placeholder="姓名"/>
              </FormItem>
              <FormItem prop="sex">
                <RadioGroup v-model="baseForm.sex">
                  <Radio :label="1">男</Radio>
                  <Radio :label="2">女</Radio>
                </RadioGroup>
              </FormItem>
              <FormItem>
                <Input type="text" v-model="baseForm.mobile" placeholder="手机号"/>
              </FormItem>
              <FormItem>
                <Input type="text" v-model="baseForm.remark" placeholder="备注"/>
              </FormItem>
              <FormItem>
                <Button type="primary" size="small" @click="saveTeacher('baseForm')">保存</Button>
              </FormItem>
            </Form>
        </Col>
        <Col span="12">
        <table class="tb1" cellpadding="0" cellspacing="0">
          <template v-for="courseType in courseList">
            <tr>
              <td style="width:100px;font-weight: 700 ;margin:5px;">
                <Checkbox @on-change="changePerm(courseType.has,courseType.id,1)" :true-value="1" :false-value="0"
                          v-model="courseType.has" style="font-size:18px;">{{courseType.name}}
                </Checkbox>
              </td>
            </tr>
            <tr>
              <td>
                <table class="noborder">
                  <tr>
                    <template v-for="course in courseType.courselist">
                      <td class="thick" style="width:120px;padding-left:20px;">
                        <Checkbox @on-change="changePerm(course.has,course.id,2)" :true-value="1" :false-value="0"
                                  v-model="course.has">{{course.name}}
                        </Checkbox>
                      </td>
                    </template>
                  </tr>
                </table>
              </td>
            </tr>
          </template>
        </table>
        </Col>
      </Row>
  </div>
</template>
<script>
  export default {
    name: 'teacher_base',
    data() {
      return {
        baseForm: {
          id: '',
          name: '',
          sex: 1,
          mobile: '',
          remark: ''
        },
        baseRules: {
          name: [{required: true, message: '请输入姓名', trigger: 'blur'}],
        },
        courseList: [],
      }
    },
    methods: {
      getTeacherBase() {
        this.$api.teacher.getTeacherBase({id: this.baseForm.id}).then(res => {
          if (res.state == "ok") {
            this.baseForm = res.base;
           this.getTeacherCourse()
          } else {
            this.$Message.error(res.msg);
          }
        })
      },
      getTeacherCourse(){
        this.$api.teacher.getTeacherCourse({teacher_id: this.baseForm.id}).then(resp => {
          this.courseList = resp.courseList
        })
      },
      changePerm(val, id, level) {
        if (level == 1) {
          this.courseList.every(function (perm) {
            if (perm.id == id) {
              perm.courselist && perm.courselist.every(function (perm2) {
                perm2.has = val;
                return true
              })
              return false
            }
            return true
          })
        } else if (level == 2) {
          this.courseList.every(function (perm) {
            let parenthas = 0;
            let isperm1 = false;
            perm.courselist && perm.courselist.every(function (perm2) {
              if (perm2.id == id) {
                isperm1 = true;
              }
              if (perm2.has) {
                parenthas = 1;
                if (isperm1) {
                  return false
                } else {
                  return true
                }
              } else {
                return true
              }

            })
            if (isperm1) {
              perm.has = parenthas;
              return false
            } else {
              return true
            }
          })
        }
      },
      packagingFormData() {
        let postFormData = {};
        for (var i in this.baseForm) {
          if (this.baseForm.hasOwnProperty(i)) {
            postFormData['teacher.' + i] = this.baseForm[i];
          }
        }
        let permArray = [];
        this.courseList && this.courseList.forEach(function (perm1) {
          perm1.courselist && perm1.courselist.forEach(function (perm2) {
            if (perm2.has) {
              permArray.push(perm2.id);
            }
          });
        });
        postFormData['courstr'] = permArray.join(",");
        console.log(permArray)
        return postFormData;
      },
      saveTeacher(name) {
        let self = this
        self.$refs[name].validate((valid) => {
          if (valid) {
            this.$api.teacher.saveTeacher(this.packagingFormData()).then(res => {
              if (res.state == "ok") {
                this.$Message.success("添加成功");
                this.$router.push({
                  name: 'teacher_index',
                  params: {reload: true}
                })
              } else {
                this.$Message.error(res.msg)
              }
            })
          } else {
            this.$Message.error("表单验证不通过")
          }
        })

      },
      init(){
        this.$refs.baseForm.resetFields()
      }
    }
  }
</script>
